// [Ticket]
// String id;
// DateTime createAt;
// String name;
// String description;
// int price;
// int dollarPrice;
// int months;
// int clinicCount;
// [User]
// String id;
// DateTime createAt;
// String recentLoginVersion;
// bool isAdditionalInfoComplete;
// String email;
// String name;
// String nickname;
// DateTime birth;
// String profileImageUrl;
// String profileImageBlurHash;
// UserType userType;
// MembershipType membershipType;
// SignUpMethod signUpMethod;
// int point;
// String myInvitationLink;
// bool allowMarketing;
// String pushToken;
// List<dynamic> blockIds;
// List<dynamic> reportPostIds;
// List<dynamic> reportCommentIds;
// List<dynamic> myNotiKeywordList;
// List<dynamic> myChatRoomList;
// String gender;
// String di;
// String phone;
// CancerStateModel cancerState;
// String ticketId;
// any ticket;
// DateTime ticketStartDate;
// DateTime ticketEndDate;
// int clinicCount;
// String companyName;
// String cardNumber;
// String consultantId;
// String doctorId;
// String customerServiceCenterChatId;
// String myMainCardId;
// String myMainCardBillingKey;
// String doctorType;
// String consultantType;
// List<dynamic> bio;
// String message;
// List<dynamic> hashtags;
// bool online;
// String consultingState;
// bool prevConsultiongState;
// bool isMain;
// int order;
// List<dynamic> customers;
// String accountBank;
// String accountNumber;
// String accountOwner;
// bool enableAutoMatching;
// bool show;
// [ReviewScore]
// String id;
// DateTime createAt;
// double score;
// String doctorId;
// UserModel doctor;
// String writerId;
// UserModel writer;
// String message;
// [Solution]
// String id;
// DateTime createAt;
// String category;
// String title;
// String imageUrl;
// String subTitle;
// String contents;
// int order;
// [TreatmentCase]
// String id;
// DateTime createAt;
// String title;
// String imageUrl;
// String subTitle;
// DateTime writeDate;
// String contents;
// String category;
// String fileUrl;
// int order;
// [Notice]
// String id;
// DateTime createAt;
// List<dynamic> target;
// String title;
// String content;
// String imageUrl;
// String filePath;
// [Payment]
// String id;
// DateTime createAt;
// String paymentId;
// String state;
// String consultationId;
// String ticketId;
// any ticket;
// String userId;
// any user;
// String consultantId;
// DateTime paymentAt;
// any paymentResult;
// String deliveryServiceCompany;
// String invoiceNumber;
// DateTime deliveryStartAt;
// DateTime deliveryEndAt;
// String receptionUserName;
// String phoneNumber;
// String address;
// String addressDetail;
// String deliveryRequestMessage;
// int amount;
// int dollarAmount;
// String memo;
// [ChatRoom]
// String id;
// DateTime createAt;
// DateTime updateAt;
// List<dynamic> memberIds;
// any memberImagesById;
// any memberNicknameById;
// any memberRealnameById;
// any memberRecentSeenById;
// String lastMessage;
// ChatMessageModel lastMessageModel;
// bool isFinished;
// String type;
// String consultationId;
// [NotificationSchedule]
// String id;
// DateTime createAt;
// String title;
// String message;
// bool periodic;
// DateTime reservedAt;
// int dayInterval;
// int hour;
// int minute;
// DateTime sendedAt;
// [Keyword]
// String id;
// DateTime createAt;
// String keyword;
// bool selected;
// [TranslationLanguage]
// String id;
// DateTime createAt;
// String name;
// String languageCode;

/* eslint-disable no-unused-vars */
import Vue from "vue";
export default {
};

function isNull(text) {
	if ((typeof text == "undefined") || (text == null)) {
		return true;
	}
	else {
		return false;
	}
}

function toNumber(text) {
	if (isNull(text)) {
		return null;
	}
	else {
		return text * 1;
	}
}

function toText(number) {
	if (isNull(number)) {
		return null;
	}
	else {
		return number + '';
	}
}

function toSafeValue(value) {
	if (isNull(value)) {
		return null;
	}
	else {
		return value;
	}
}

export const models = {
	install(Vue) {
		Vue.prototype.$models = {
			TicketModel: {
				create: function () {
					return {
						id: '',
						createAt: null,
						name: '',
						description: '',
						price: 0,
						dollarPrice: 0,
						months: 0,
						clinicCount: 0,
					};
				},
				set: function (model) {
					return {
						id: toText(model.id),
						createAt: toSafeValue(model.createAt),
						name: toText(model.name),
						description: toText(model.description),
						price: toNumber(model.price),
						dollarPrice: toNumber(model.dollarPrice),
						months: toNumber(model.months),
						clinicCount: toNumber(model.clinicCount),
					};
				},
			},

			UserModel: {
				create: function () {
					return {
						id: '',
						createAt: null,
						recentLoginVersion: '',
						isAdditionalInfoComplete: null,
						email: '',
						name: '',
						nickname: '',
						birth: null,
						profileImageUrl: '',
						profileImageBlurHash: '',
						userType: null,
						membershipType: null,
						signUpMethod: null,
						point: 0,
						myInvitationLink: '',
						allowMarketing: null,
						pushToken: '',
						blockIds: null,
						reportPostIds: null,
						reportCommentIds: null,
						myNotiKeywordList: null,
						myChatRoomList: null,
						gender: '',
						di: '',
						phone: '',
						cancerState: null,
						ticketId: '',
						ticket: null,
						ticketStartDate: null,
						ticketEndDate: null,
						clinicCount: 0,
						companyName: '',
						cardNumber: '',
						consultantId: '',
						doctorId: '',
						customerServiceCenterChatId: '',
						myMainCardId: '',
						myMainCardBillingKey: '',
						doctorType: '',
						consultantType: '',
						bio: null,
						message: '',
						hashtags: null,
						online: null,
						consultingState: '',
						prevConsultiongState: null,
						isMain: null,
						order: 0,
						customers: null,
						accountBank: '',
						accountNumber: '',
						accountOwner: '',
						enableAutoMatching: null,
						show: null,
					};
				},
				set: function (model) {
					return {
						id: toText(model.id),
						createAt: toSafeValue(model.createAt),
						recentLoginVersion: toText(model.recentLoginVersion),
						isAdditionalInfoComplete: toSafeValue(model.isAdditionalInfoComplete),
						email: toText(model.email),
						name: toText(model.name),
						nickname: toText(model.nickname),
						birth: toSafeValue(model.birth),
						profileImageUrl: toText(model.profileImageUrl),
						profileImageBlurHash: toText(model.profileImageBlurHash),
						userType: toSafeValue(model.userType),
						membershipType: toSafeValue(model.membershipType),
						signUpMethod: toSafeValue(model.signUpMethod),
						point: toNumber(model.point),
						myInvitationLink: toText(model.myInvitationLink),
						allowMarketing: toSafeValue(model.allowMarketing),
						pushToken: toText(model.pushToken),
						blockIds: toSafeValue(model.blockIds),
						reportPostIds: toSafeValue(model.reportPostIds),
						reportCommentIds: toSafeValue(model.reportCommentIds),
						myNotiKeywordList: toSafeValue(model.myNotiKeywordList),
						myChatRoomList: toSafeValue(model.myChatRoomList),
						gender: toText(model.gender),
						di: toText(model.di),
						phone: toText(model.phone),
						cancerState: toSafeValue(model.cancerState),
						ticketId: toText(model.ticketId),
						ticket: toSafeValue(model.ticket),
						ticketStartDate: toSafeValue(model.ticketStartDate),
						ticketEndDate: toSafeValue(model.ticketEndDate),
						clinicCount: toNumber(model.clinicCount),
						companyName: toText(model.companyName),
						cardNumber: toText(model.cardNumber),
						consultantId: toText(model.consultantId),
						doctorId: toText(model.doctorId),
						customerServiceCenterChatId: toText(model.customerServiceCenterChatId),
						myMainCardId: toText(model.myMainCardId),
						myMainCardBillingKey: toText(model.myMainCardBillingKey),
						doctorType: toText(model.doctorType),
						consultantType: toText(model.consultantType),
						bio: toSafeValue(model.bio),
						message: toText(model.message),
						hashtags: toSafeValue(model.hashtags),
						online: toSafeValue(model.online),
						consultingState: toText(model.consultingState),
						prevConsultiongState: toSafeValue(model.prevConsultiongState),
						isMain: toSafeValue(model.isMain),
						order: toNumber(model.order),
						customers: toSafeValue(model.customers),
						accountBank: toText(model.accountBank),
						accountNumber: toText(model.accountNumber),
						accountOwner: toText(model.accountOwner),
						enableAutoMatching: toSafeValue(model.enableAutoMatching),
						show: toSafeValue(model.show),
					};
				},
			},

			ReviewScoreModel: {
				create: function () {
					return {
						id: '',
						createAt: null,
						score: 0,
						doctorId: '',
						doctor: null,
						writerId: '',
						writer: null,
						message: '',
					};
				},
				set: function (model) {
					return {
						id: toText(model.id),
						createAt: toSafeValue(model.createAt),
						score: toNumber(model.score),
						doctorId: toText(model.doctorId),
						doctor: toSafeValue(model.doctor),
						writerId: toText(model.writerId),
						writer: toSafeValue(model.writer),
						message: toText(model.message),
					};
				},
			},

			SolutionModel: {
				create: function () {
					return {
						id: '',
						createAt: null,
						category: '',
						title: '',
						imageUrl: '',
						subTitle: '',
						contents: '',
						order: 0,
					};
				},
				set: function (model) {
					return {
						id: toText(model.id),
						createAt: toSafeValue(model.createAt),
						category: toText(model.category),
						title: toText(model.title),
						imageUrl: toText(model.imageUrl),
						subTitle: toText(model.subTitle),
						contents: toText(model.contents),
						order: toNumber(model.order),
					};
				},
			},

			TreatmentCaseModel: {
				create: function () {
					return {
						id: '',
						createAt: null,
						title: '',
						imageUrl: '',
						subTitle: '',
						writeDate: null,
						contents: '',
						category: '',
						fileUrl: '',
						order: 0,
					};
				},
				set: function (model) {
					return {
						id: toText(model.id),
						createAt: toSafeValue(model.createAt),
						title: toText(model.title),
						imageUrl: toText(model.imageUrl),
						subTitle: toText(model.subTitle),
						writeDate: toSafeValue(model.writeDate),
						contents: toText(model.contents),
						category: toText(model.category),
						fileUrl: toText(model.fileUrl),
						order: toNumber(model.order),
					};
				},
			},

			NoticeModel: {
				create: function () {
					return {
						id: '',
						createAt: null,
						target: null,
						title: '',
						content: '',
						imageUrl: '',
						filePath: '',
					};
				},
				set: function (model) {
					return {
						id: toText(model.id),
						createAt: toSafeValue(model.createAt),
						target: toSafeValue(model.target),
						title: toText(model.title),
						content: toText(model.content),
						imageUrl: toText(model.imageUrl),
						filePath: toText(model.filePath),
					};
				},
			},

			PaymentModel: {
				create: function () {
					return {
						id: '',
						createAt: null,
						paymentId: '',
						state: '',
						consultationId: '',
						ticketId: '',
						ticket: null,
						userId: '',
						user: null,
						consultantId: '',
						paymentAt: null,
						paymentResult: null,
						deliveryServiceCompany: '',
						invoiceNumber: '',
						deliveryStartAt: null,
						deliveryEndAt: null,
						receptionUserName: '',
						phoneNumber: '',
						address: '',
						addressDetail: '',
						deliveryRequestMessage: '',
						amount: 0,
						dollarAmount: 0,
						memo: '',
					};
				},
				set: function (model) {
					return {
						id: toText(model.id),
						createAt: toSafeValue(model.createAt),
						paymentId: toText(model.paymentId),
						state: toText(model.state),
						consultationId: toText(model.consultationId),
						ticketId: toText(model.ticketId),
						ticket: toSafeValue(model.ticket),
						userId: toText(model.userId),
						user: toSafeValue(model.user),
						consultantId: toText(model.consultantId),
						paymentAt: toSafeValue(model.paymentAt),
						paymentResult: toSafeValue(model.paymentResult),
						deliveryServiceCompany: toText(model.deliveryServiceCompany),
						invoiceNumber: toText(model.invoiceNumber),
						deliveryStartAt: toSafeValue(model.deliveryStartAt),
						deliveryEndAt: toSafeValue(model.deliveryEndAt),
						receptionUserName: toText(model.receptionUserName),
						phoneNumber: toText(model.phoneNumber),
						address: toText(model.address),
						addressDetail: toText(model.addressDetail),
						deliveryRequestMessage: toText(model.deliveryRequestMessage),
						amount: toNumber(model.amount),
						dollarAmount: toNumber(model.dollarAmount),
						memo: toText(model.memo),
					};
				},
			},

			ChatRoomModel: {
				create: function () {
					return {
						id: '',
						createAt: null,
						updateAt: null,
						memberIds: null,
						memberImagesById: null,
						memberNicknameById: null,
						memberRealnameById: null,
						memberRecentSeenById: null,
						lastMessage: '',
						lastMessageModel: null,
						isFinished: null,
						type: '',
						consultationId: '',
					};
				},
				set: function (model) {
					return {
						id: toText(model.id),
						createAt: toSafeValue(model.createAt),
						updateAt: toSafeValue(model.updateAt),
						memberIds: toSafeValue(model.memberIds),
						memberImagesById: toSafeValue(model.memberImagesById),
						memberNicknameById: toSafeValue(model.memberNicknameById),
						memberRealnameById: toSafeValue(model.memberRealnameById),
						memberRecentSeenById: toSafeValue(model.memberRecentSeenById),
						lastMessage: toText(model.lastMessage),
						lastMessageModel: toSafeValue(model.lastMessageModel),
						isFinished: toSafeValue(model.isFinished),
						type: toText(model.type),
						consultationId: toText(model.consultationId),
					};
				},
			},

			NotificationScheduleModel: {
				create: function () {
					return {
						id: '',
						createAt: null,
						title: '',
						message: '',
						periodic: null,
						reservedAt: null,
						dayInterval: 0,
						hour: 0,
						minute: 0,
						sendedAt: null,
					};
				},
				set: function (model) {
					return {
						id: toText(model.id),
						createAt: toSafeValue(model.createAt),
						title: toText(model.title),
						message: toText(model.message),
						periodic: toSafeValue(model.periodic),
						reservedAt: toSafeValue(model.reservedAt),
						dayInterval: toNumber(model.dayInterval),
						hour: toNumber(model.hour),
						minute: toNumber(model.minute),
						sendedAt: toSafeValue(model.sendedAt),
					};
				},
			},

			KeywordModel: {
				create: function () {
					return {
						id: '',
						createAt: null,
						keyword: '',
						selected: null,
					};
				},
				set: function (model) {
					return {
						id: toText(model.id),
						createAt: toSafeValue(model.createAt),
						keyword: toText(model.keyword),
						selected: toSafeValue(model.selected),
					};
				},
			},

			TranslationLanguageModel: {
				create: function () {
					return {
						id: '',
						createAt: null,
						name: '',
						languageCode: '',
					};
				},
				set: function (model) {
					return {
						id: toText(model.id),
						createAt: toSafeValue(model.createAt),
						name: toText(model.name),
						languageCode: toText(model.languageCode),
					};
				},
			},
		};
	}
};

Vue.use(models);
